/* eslint-disable */

import React from 'react';
import { t } from 'ttag';
import * as Sentry from '@sentry/react';
import addToCart from '../../SliderLib/ProductSlider/actions/addToCart';
import ProductLabels from '../Labels/ProductLabels';
import { trackStructEvent } from '../../utils/snowplow';
import gtmPusher from '../../utils/gtmPusher';
import selectItem from '../../utils/ga4/selectItem';
import Price from '../../utils/prices';
import LockedSvg from '../../sharedSvgs/LockedSvg';
import UnlockedSvg from '../../sharedSvgs/UnlockedSvg';

import arrayToString from '../../utils/js/arrayToString';

import './product.less';

class Product extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { value: '' };
  }

  handleGoogleAnalytics = (event, action, position) => {
    // GOOGLE ANALYTICS
    let list = this.props.sliderType
      ? `product slider: ${this.props.sliderType}`
      : 'campaign laydown';
    list = this.props.list || list;

    const ecommerceObj = {
      event,
      eventCategory: 'ecommerce',
      eventAction: action,
      eventLabel: 'product',
      eventValue: 0,
      eventNonInteraction: false,
      currencyCode: this.props.product.currency,
      list
    };

    let size = null;
    if (event === 'addToCart') {
      size = this.props.product.stock.filter(
        sizeObj => Number(sizeObj.pk) === Number(this.state.value)
      )[0].name;
    }
    const productArr = [
      {
        ...this.props.product,
        product_id: this.props.product.id,
        product: this.props.product.name,
        quantity: 1,
        unit_net: this.props.product.prices.min_price,
        size,
        variant: '',
        position
      }
    ];
    gtmPusher(ecommerceObj, productArr);
    // -- END GOOGLE ANALYTICS --
  };

  handleProductClick = (e, refId, refPos, productData) => {
    trackStructEvent(
      this.props.location ? `${this.props.location}Product` : 'sliderProduct',
      'click',
      refId,
      { pos: refPos }
    );
    const { product, itemListId, itemListName } = this.props;
    selectItem(
      product,
      itemListId || 'product_slider',
      itemListName || 'Product Slider'
    );
    if (this.props.productClick) {
      e.preventDefault();
      this.props.productClick(productData);
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    if (this.state.value) {
      this.handleGoogleAnalytics('addToCart', 'add to cart');
      addToCart(this.props.product.id, this.state.value)
        .then(() => {
          if (this.props.isCampaign) {
            window.popupContainer.hello(
              this.props.commonTranslations.addedsuccessfully
            );
          } else {
            if (window.popupContainer) {
              window.popupContainer.hello(t`Product was added to the cart`);
            }
            return null;
          }
          return null;
        })
        .catch(() => {
          // No error handling
        });
    } else {
      // this.setState({
      //     error: t`The field must be filled`,
      // });
    }
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  determineProductContent = () => {
    if (
      this.props.product.stock.length > 0 &&
      this.props.addToCartForm &&
      !this.props.isBootroom
    ) {
      return (
        <form
          className="form-group select cart-form"
          action="/cart/items/add_to_cart/"
          method="post"
          noValidate="novalidate"
          onSubmit={this.handleSubmit}
        >
          <div className="select">
            <div>
              <select
                name="size"
                aria-required="true"
                aria-label="select size"
                required="required"
                className="swiper-no-swiping formControl valid select"
                defaultValue={this.state.value}
                onChange={this.handleChange}
              >
                <option className="choose-size option" value="" disabled>
                  {t`Select size`}
                </option>
                {this.props.product.stock.map(size => {
                  return (
                    <option className="option" value={size.pk} key={size.pk}>
                      {size.name}
                      {size.stock_info === '' ? '' : ` - ${size.stock_info}`}
                    </option>
                  );
                })}
              </select>
              {this.state.error ? (
                <div className="slider-error" htmlFor="id_size">
                  {this.state.error}
                </div>
              ) : (
                ''
              )}
            </div>
            <button
              className="productAddToCart"
              type="submit"
              value="Submit"
              data-cta={this.props.addToCartCta}
            >
              {t`Add to cart`}
            </button>
          </div>
        </form>
      );
    }
    if (this.props.product.stock.length > 0 && !this.props.addToCartForm) {
      const sizesArr = [];
      this.props.product.stock.forEach(stock => {
        sizesArr.push(stock.name_short);
      });
      return this.renderSizes(sizesArr);
      // Beta purposes, this 2 lines of comment HAVE to be removed after approval
      // return this.renderSizesDeprecated(sizesArr, this.props);
    }
    return null;
  };

  handleRenderPrice = (prices, discount) => {
    try {
      const minPrice = new Price(prices.min_price, this.props.product.currency);
      const maxPrice = new Price(prices.max_price, this.props.product.currency);
      const Rrp = new Price(
        prices.recommended_retail_price || 0,
        this.props.product.currency
      );
      return (
        <>
          <div
            className={`productPrice ${
              prices.min !== prices.max && 'no-padding'
            }`}
          >
            {!minPrice.equals(maxPrice) && (
              <span className="from">{t`From`}</span>
            )}
            {minPrice.toString()}
          </div>
          <div className="oldPrice">
            {minPrice.equals(maxPrice) &&
              discount > 0 &&
              Rrp.greaterThan(0) &&
              Rrp.toString()}
          </div>
        </>
      );
    } catch (error) {
      Sentry.captureException(error);
      return null;
    }
  };

  returnString(sizesArr) {
    if (sizesArr.length > 4) {
      return t`Many sizes available`;
    }
    return sizesArr.join(', ');
  }

  renderSizes(sizesArr) {
    return (
      <div className="sizes-wrap">
        <span className="size-label">
          {t`Size`.toUpperCase()}
          {': '}
        </span>
        <span className="sizes">{this.returnString(sizesArr)}</span>
      </div>
    );
  }

  render() {
    const isRomanianSite =
      typeof window !== 'undefined' && window.config?.pageMarket === 'ro';
    const discount = this.props.product.prices
      ? this.props.product.prices.discount_percentage
      : 0;
    const BFCondition = window.config ? window.config.black_friday_ff : false;

    function discountElem() {
      if (discount > 0) {
        return (
          <div className={`splash ${arrayToString(BFCondition)}`}>
            {isRomanianSite ? t`DEAL` : `-${discount}%`}
          </div>
        );
      }
      return null;
    }

    const { refId } = this.props;
    const { refPos } = this.props;
    const { prices } = this.props.product;

    // On search, we want to provide query params to the product urls
    let url = this.props.product.relative_url;
    if (this.props.location && this.props.location === 'search') {
      url = `${url}?ref_id=${this.props.searchRefId}&ref=search&ref_pos=${this.props.currentPage}-${refPos}`;
    }

    const exclusiveIcon = () => {
      try {
        let lockIcon;
        if (this.props.product.is_exclusive) {
          if (window.config.loginStatus) {
            lockIcon = <UnlockedSvg />;
          }
          if (!window.config.loginStatus) {
            lockIcon = <LockedSvg />;
          }
        }
        return lockIcon;
      } catch (error) {
        Sentry.captureException(error);
        return null;
      }
    };

    const productClasses = ['sliderProduct'];
    if (this.props.isCampaign) productClasses.push('sliderProduct--withSpace');
    if (this.props.location === 'category' || this.props.location === 'search')
      productClasses.push('full-height');

    return (
      <div className={productClasses.join(' ')}>
        <a
          href={url}
          data-cta={this.props.goToProductDataCta}
          onClick={e =>
            !this.props.isDragging &&
            this.handleProductClick(e, refId, refPos, this.props.product)
          }
        >
          {this.props.product.labels ? (
            <ProductLabels
              labels={this.props.product.labels}
              splash={prices.min === prices.max ? discountElem() : null}
              extraClasses={arrayToString(BFCondition)}
              isProductPage={false}
            />
          ) : null}
          {(this.props.isLaydown || this.props.list) &&
            !this.props.slickSlider && (
              <img
                className={`productImage lazyload ${
                  this.props.location === 'category' ||
                  this.props.location === 'search'
                    ? 'full-height'
                    : ''
                }`}
                data-src={this.props.product.image}
                data-testid="product-image"
                alt={this.props.product.name}
              />
            )}
          {this.props.slickSlider && (
            <img
              src={this.props.product.image}
              data-testid="product-image"
              className="productImage"
              alt={this.props.product.name}
            />
          )}

          <div className="productName" data-id={this.props.product.id}>
            {exclusiveIcon()} {this.props.product.name}
          </div>
          {this.handleRenderPrice(prices, discount)}
          {/* this.props.product.delivery &&
            <div className="delivery-wrap">
              <p className="delivery-p">
                {t`Delivery`}
                {': '}
                <span className="delivery">
                  {this.props.product.delivery}
                </span>
              </p>
            </div>
          */}
        </a>
        {this.determineProductContent()}
      </div>
    );
  }
}

export default Product;
